import React from 'react';
import { Modal, Badge } from 'react-bootstrap';
import { TOPIC_SENSOR } from '../../constants';
import { Heading5 } from '../widgets';

const LogModal = (props) => {
    const message = props.logInfo.message && props.logInfo.message.hasOwnProperty('gps')
        ? props.logInfo.message.gps.data : (props.logInfo.message ? props.logInfo.message : {});

    const topicName = props.logInfo.name === TOPIC_SENSOR ? "q-present" : "q-lost";

    return <Modal show={true} backdrop="static" onHide={props.onClose} size='lg' className="console-modal">
        <Modal.Header closeButton style={{ color: '#064d9e' }}>
            <Modal.Title >
                <Heading5>
                    <span className="mr-1">EG Name :</span>
                    <span>{message.equipment_group.equipment_group_name}</span>
                    <span className="pl-1">
                        <Badge pill variant={props.logInfo.name === TOPIC_SENSOR ? "success" : "danger"}>{topicName}</Badge>
                    </span>
                </Heading5>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <pre className="response">
                {JSON.stringify(message, null, 2)}
            </pre>
        </Modal.Body>
    </Modal>
};

export default LogModal;